"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CellLabel = exports.CellLabelDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var cn_1 = require("../../utils/cn");
var cls = (0, cn_1.classNames)('cell-label');
exports.CellLabelDefaultProps = {
  tag: 'h4',
  variant: 'normal'
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", ";\n    font-weight: 400;\n    margin: 0;\n    color: ", ";\n    text-transform: uppercase;\n\n    ", "\n  "], ["\n    font-size: ", ";\n    font-weight: 400;\n    margin: 0;\n    color: ", ";\n    text-transform: uppercase;\n\n    ", "\n  "])), theme_1.theme.FONT_SIZE(13), theme_1.theme.COLOR('text'), function (_a) {
    var variant = _a.variant;
    return variant === 'form' && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      font-weight: 500 !important;\n      font-size: ", ";\n    "], ["\n      font-weight: 500 !important;\n      font-size: ", ";\n    "])), theme_1.theme.FONT_SIZE(14));
  })
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.h4(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
var CellLabel = function (props) {
  var className = props.className,
    children = props.children,
    tag = props.tag;
  return (
    // @ts-ignore
    react_1.default.createElement(My.Container, {
      as: tag,
      className: cls.name(className)
    }, children)
  );
};
exports.CellLabel = CellLabel;
exports.CellLabel.cls = cls;
exports.CellLabel.defaultProps = exports.CellLabelDefaultProps;
var templateObject_1, templateObject_2, templateObject_3;